import Router from 'src/routes/section';

import ThemeProvider from "src/theme";

import './global.css';

function App() {
  return (
    <ThemeProvider>
      <Router />
    </ThemeProvider>
  );
}

export default App;
